import React, { useState } from "react";
import {
  Container,
  Box,
  AppBar,
  Tabs,
  Tab,
  Typography,
  Button,
} from "@material-ui/core";
import Page from "../components/Page.js";
import { Titulo } from "../components/Titulo.js";
import LotesTable from "src/components/conciliacion/LotesTable.js";
import { Add } from "@material-ui/icons";
import ModalUploadCartola from "src/components/conciliacion/ModalUploadCartola.js";
import MovimientosTable from "src/components/conciliacion/MovimientosTable.js";
import HistorialTable from "src/components/conciliacion/HistorialTable.js";
import RutsAlternativosTable from "src/components/conciliacion/RutsAlternativosTable.js";
import TablaAbonosPendientes from "src/components/conciliacion/TablaAbonosPendientes.js";
import CategoriasContablesTable from "src/components/conciliacion/CategoriasContablesTable.js";
// Componente auxiliar para los paneles de tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`conciliacion-tabpanel-${index}`}
      aria-labelledby={`conciliacion-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

// Helper para accesibilidad de tabs
function a11yProps(index) {
  return {
    id: `conciliacion-tab-${index}`,
    "aria-controls": `conciliacion-tabpanel-${index}`,
  };
}

export default function ConciliacionBancaria() {
  const [tabIndex, setTabIndex] = useState(0);
  const [loteSeleccionado, setLoteSeleccionado] = useState(null);
  const [openModalUpload, setOpenModalUpload] = useState(false);

  const handleChangeTab = (event, newValue) => {
    setTabIndex(newValue);
  };

  // Callback que usaremos cuando clickeen "Ver Movimientos" en un lote
  const handleVerMovimientos = (loteId) => {
    setLoteSeleccionado(loteId);
    setTabIndex(1); // Cambiar a tab de Movimientos
  };

  return (
    <Page title="Conciliación Bancaria">
      <Container maxWidth="xl">
        <Titulo>
          <Typography variant="h4" gutterBottom>
            Conciliación Bancaria
          </Typography>
        </Titulo>

        <Box sx={{ width: "100%", mt: 3 }}>
          <AppBar position="static" color="default">
            <Tabs
              value={tabIndex}
              onChange={handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="Cargar Cartola" {...a11yProps(0)} />
              <Tab label="Movimientos" {...a11yProps(1)} />
              <Tab label="Historial" {...a11yProps(2)} />
              <Tab label="Abonos Pendientes" {...a11yProps(3)} />
              <Tab label="RUTs Alternativos" {...a11yProps(4)} />
              <Tab label="Configuración" {...a11yProps(5)} />
            </Tabs>
          </AppBar>

          {/* TAB 0: Cargar Cartola */}
          <TabPanel value={tabIndex} index={0}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography variant="h6">📋 Lotes Cargados</Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={() => setOpenModalUpload(true)}
              >
                Cargar Cartola
              </Button>
            </Box>

            <LotesTable onVerMovimientos={handleVerMovimientos} />

            {/* Modal de Upload */}
            <ModalUploadCartola
              open={openModalUpload}
              setOpen={setOpenModalUpload}
            />
          </TabPanel>

          {/* TAB 1: Movimientos */}
          <TabPanel value={tabIndex} index={1}>
            <Box sx={{ mb: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6">💰 Movimientos Bancarios</Typography>

                {loteSeleccionado && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      setLoteSeleccionado(null);
                      setTabIndex(0);
                    }}
                  >
                    ← Volver a Lotes
                  </Button>
                )}
              </Box>

              {loteSeleccionado && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2" color="textSecondary">
                    Mostrando movimientos del lote seleccionado
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Tabla de Movimientos */}
            <MovimientosTable loteId={loteSeleccionado} />
          </TabPanel>

          {/* Tab 2: Historial */}
          <TabPanel value={tabIndex} index={2}>
            <HistorialTable />
          </TabPanel>

          {/* TAB 3: Abonos Pendientes */}
          <TabPanel value={tabIndex} index={3}>
            <TablaAbonosPendientes />
          </TabPanel>

          {/* TAB 4: RUTs Alternativos */}
          <TabPanel value={tabIndex} index={4}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6">🔗 RUTs Alternativos</Typography>
              <Typography variant="body2" color="textSecondary">
                Gestiona relaciones entre RUTs (holdings, sucursales, filiales)
                para mejorar el matching automático
              </Typography>
            </Box>

            <RutsAlternativosTable />
          </TabPanel>

          {/* TAB 5: Configuración - Categorías Contables */}
          <TabPanel value={tabIndex} index={5}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6">⚙️ Configuración</Typography>
              <Typography variant="body2" color="textSecondary">
                Administra las categorías contables para clasificar comisiones y
                ajustes
              </Typography>
            </Box>

            <CategoriasContablesTable />
          </TabPanel>
        </Box>
      </Container>
    </Page>
  );
}
